import React from 'react';
import { FadeIn } from '../ui/FadeIn';
export function PhasesSection() {
  return <section className="py-20 px-6 bg-forest text-white" data-id="element-345">
      <div className="max-w-4xl mx-auto" data-id="element-346">
        <FadeIn data-id="element-347">
          <h2 className="text-4xl md:text-5xl font-bold text-center mb-16 text-cream" data-id="element-348">
            Cómo funciona
          </h2>

          <div className="space-y-8 relative before:absolute before:inset-0 before:ml-5 before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-1 before:bg-gradient-to-b before:from-transparent before:via-amber/50 before:to-transparent" data-id="element-349">
            <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-350">
              <div className="flex items-center justify-center w-10 h-10 rounded-full border-4 border-forest bg-amber shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 shadow-xl z-10" data-id="element-351">
                <span className="font-bold text-forest" data-id="element-352">1</span>
              </div>
              <div className="w-[calc(100%-4rem)] md:w-[calc(50%-2.5rem)] bg-white/10 backdrop-blur-md p-6 md:p-8 rounded-2xl border border-white/20 shadow-xl" data-id="element-353">
                <h3 className="text-amber font-bold text-xl mb-2" data-id="element-354">
                  Fase 1 (Días 1-3)
                </h3>
                <p className="text-lg text-cream/90" data-id="element-355">
                  Detenemos el daño ácido y desinflamamos.
                </p>
              </div>
            </div>

            <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-356">
              <div className="flex items-center justify-center w-10 h-10 rounded-full border-4 border-forest bg-amber shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 shadow-xl z-10" data-id="element-357">
                <span className="font-bold text-forest" data-id="element-358">2</span>
              </div>
              <div className="w-[calc(100%-4rem)] md:w-[calc(50%-2.5rem)] bg-white/10 backdrop-blur-md p-6 md:p-8 rounded-2xl border border-white/20 shadow-xl" data-id="element-359">
                <h3 className="text-amber font-bold text-xl mb-2" data-id="element-360">
                  Fase 2 (Días 4-10)
                </h3>
                <p className="text-lg text-cream/90" data-id="element-361">
                  Ejecutamos el lavado profundo con el recetario de 50 platos.
                </p>
              </div>
            </div>

            <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-362">
              <div className="flex items-center justify-center w-10 h-10 rounded-full border-4 border-forest bg-amber shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 shadow-xl z-10" data-id="element-363">
                <span className="font-bold text-forest" data-id="element-364">3</span>
              </div>
              <div className="w-[calc(100%-4rem)] md:w-[calc(50%-2.5rem)] bg-white/10 backdrop-blur-md p-6 md:p-8 rounded-2xl border border-white/20 shadow-xl" data-id="element-365">
                <h3 className="text-amber font-bold text-xl mb-2" data-id="element-366">
                  Fase 3 (Días 11-14)
                </h3>
                <p className="text-lg text-cream/90" data-id="element-367">
                  Blindamos tus resultados y preparamos tu nueva vida.
                </p>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}